/*
  Ebbrest: общий скрипт своих секций. Без библиотек. Подключается один раз в head с defer (snippets/eb-head.liquid).
  Делает две вещи: появление блоков .eb-reveal при прокрутке и общий расчёт доли прокрутки для сцен (им пользуется eb-scenes.js).

  window.EB:
    EB.reduced                 true, если у посетителя включено «уменьшить движение» (значение живое, меняется вместе с настройкой)
    EB.onReduced(fn)           fn(reduced) при смене этой настройки во время визита
    EB.scroller()              элемент, который прокручивается. ВАЖНО: в Horizon от 990 px страницу крутит .page-wrapper,
                               а не окно, поэтому window.scrollY там всегда 0 и событие scroll на window не приходит
    EB.scrollTo(y, smooth)     прокрутка этого элемента
    EB.progress(el, opts)      доля прокрутки секции от 0 до 1, разово
    EB.onProgress(el, fn, opts) подписка: fn(p, el) на каждом кадре, когда доля изменилась. Возвращает функцию отписки.
                               Один слушатель scroll и один requestAnimationFrame на все сцены, считаются только сцены у экрана.
    EB.scrollToProgress(el, p, opts) прокрутить так, чтобы сцена оказалась на доле p (тап по пилюле фазы)
    EB.reveal(scope)           запустить появление .eb-reveal внутри scope (после вставки разметки скриптом)
    EB.clamp(v, a, b), EB.lerp(a, b, t), EB.seg(p, a, b)  арифметика; seg это доля p внутри отрезка [a, b], от 0 до 1

  opts у progress, onProgress и scrollToProgress:
    sticky   липкий элемент внутри секции (узел). Не задан: берётся первый [data-eb-sticky] внутри el. false: не искать.
             Доля 0, когда липкий элемент прилип, и 1, когда он отлипает (секция выше него на свою высоту).
             Липкого элемента нет или липкость выключена (position не sticky: prefers-reduced-motion, нет класса eb-js):
             доля считается по проходу секции через экран, 0 когда верх секции у низа экрана, 1 когда низ секции у верха.
    top      высота липкой шапки в px; по умолчанию читается из вычисленного top липкого элемента
    cssVar   имя переменной, которую подписка сама пишет на el (например '--eb-p'); по умолчанию не пишет

  Когда объект готов, на document уходит событие eb:ready. Скрипты с defer идут по порядку, так что eb-scenes.js,
  подключённый после eb.js, получает window.EB сразу.
*/
(function () {
  if (window.__ebBase) return;
  window.__ebBase = true;

  var doc = document;
  var root = doc.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (fn) { return setTimeout(fn, 16); };
  var hasIO = 'IntersectionObserver' in window;

  var EB = window.EB || {};
  EB.reduced = !!(mq && mq.matches);

  EB.clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  EB.lerp = function (a, b, t) { return a + (b - a) * t; };
  EB.seg = function (p, a, b) { return b === a ? (p >= b ? 1 : 0) : EB.clamp((p - a) / (b - a), 0, 1); };

  /* Что прокручивается: .page-wrapper на компьютере, документ на телефоне */
  EB.scroller = function () {
    var w = doc.querySelector('.page-wrapper');
    if (w) {
      var oy = window.getComputedStyle(w).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && w.scrollHeight > w.clientHeight + 1) return w;
    }
    return doc.scrollingElement || root;
  };

  EB.scrollTo = function (y, smooth) {
    var s = EB.scroller();
    var behavior = smooth === false || EB.reduced ? 'auto' : 'smooth';
    try { s.scrollTo({ top: y, behavior: behavior }); } catch (e) { s.scrollTop = y; }
  };

  /* Доля прокрутки */
  var items = [];
  var io = null;
  var queued = false;

  function stickyOf(el, opts) {
    var s = opts && opts.sticky;
    if (s === false) return null;
    if (s && s.nodeType === 1) return s;
    return el.querySelector('[data-eb-sticky]');
  }

  /* Размеры меряются не на каждом кадре, а при входе сцены на экран и при смене размера окна */
  function measure(it) {
    it.stuck = false;
    it.span = 0;
    if (!it.stickyEl || !it.stickyEl.isConnected) return;
    var cs = window.getComputedStyle(it.stickyEl);
    if (cs.position !== 'sticky' && cs.position !== '-webkit-sticky') return;
    var t = typeof it.optTop === 'number' ? it.optTop : parseFloat(cs.top);
    it.topPx = t > 0 ? t : 0;
    it.span = it.el.offsetHeight - it.stickyEl.offsetHeight;
    it.stuck = it.span > 0;
  }

  function calc(it) {
    var r = it.el.getBoundingClientRect();
    if (it.stuck) return EB.clamp((it.topPx - r.top) / it.span, 0, 1);
    var vh = window.innerHeight || root.clientHeight;
    return EB.clamp((vh - r.top) / (vh + r.height), 0, 1);
  }

  function make(el, opts) {
    opts = opts || {};
    var it = { el: el, stickyEl: stickyOf(el, opts), optTop: opts.top, topPx: 0, span: 0, stuck: false };
    measure(it);
    return it;
  }

  function frame() {
    queued = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.active && !it.dirty) continue;
      if (it.dirty) measure(it);
      it.dirty = false;
      var p = calc(it);
      if (it.last !== null && Math.abs(p - it.last) < 0.0004 && !((p === 0 || p === 1) && p !== it.last)) continue;
      it.last = p;
      if (it.cssVar) it.el.style.setProperty(it.cssVar, p.toFixed(4));
      try { it.fn(p, it.el); } catch (e) { if (window.console) console.error(e); }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    raf(frame);
  }

  function refresh() {
    for (var i = 0; i < items.length; i++) items[i].dirty = true;
    schedule();
  }

  function observer() {
    if (io || !hasIO) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].el !== e.target) continue;
          items[i].active = e.isIntersecting;
          items[i].dirty = true; /* один расчёт и после ухода с экрана, чтобы сцена дошла до 0 или 1 */
        }
      });
      schedule();
    }, { rootMargin: '20% 0px 20% 0px' });
    return io;
  }

  EB.progress = function (el, opts) {
    return el ? calc(make(el, opts)) : 0;
  };

  EB.onProgress = function (el, fn, opts) {
    if (!el || typeof fn !== 'function') return function () {};
    opts = opts || {};
    var it = make(el, opts);
    it.fn = fn;
    it.cssVar = typeof opts.cssVar === 'string' ? opts.cssVar : '';
    it.active = !hasIO;
    it.dirty = true;
    it.last = null;
    items.push(it);
    if (observer()) io.observe(el);
    schedule();
    return function () {
      var at = items.indexOf(it);
      if (at > -1) items.splice(at, 1);
      var shared = false;
      for (var i = 0; i < items.length; i++) if (items[i].el === el) shared = true;
      if (io && !shared) io.unobserve(el);
    };
  };

  EB.scrollToProgress = function (el, p, opts) {
    if (!el) return;
    var it = make(el, opts);
    var s = EB.scroller();
    var r = el.getBoundingClientRect();
    var pageTop = r.top + s.scrollTop;
    var vh = window.innerHeight || root.clientHeight;
    p = EB.clamp(p, 0, 1);
    var y = it.stuck ? pageTop - it.topPx + p * it.span : pageTop - vh + p * (vh + r.height);
    EB.scrollTo(Math.max(0, Math.round(y)), opts && opts.smooth);
  };

  /* Убрать подписки на узлы, которых больше нет на странице (редактор темы перерисовал секцию) */
  function purge() {
    for (var i = items.length - 1; i >= 0; i--) {
      if (items[i].el.isConnected) continue;
      if (io) io.unobserve(items[i].el);
      items.splice(i, 1);
    }
  }

  /* scroll не всплывает, но ловится на document в фазе перехвата: так слышно и окно, и .page-wrapper */
  doc.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('orientationchange', refresh, { passive: true });
  window.addEventListener('load', refresh);

  /* Появление блоков: один раз. То, что уже на экране при загрузке, показывается сразу, без перехода. */
  var revealIo = null;

  function show(el) { el.classList.add('is-inview'); }

  EB.reveal = function (scope) {
    var host = scope && scope.querySelectorAll ? scope : doc;
    var els = host.querySelectorAll('.eb-reveal:not(.is-inview)');
    var i;
    if (!els.length) return;
    if (EB.reduced || !hasIO) {
      for (i = 0; i < els.length; i++) show(els[i]);
      return;
    }
    if (!revealIo) {
      revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          show(e.target);
          revealIo.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    var vh = window.innerHeight || root.clientHeight;
    var later = [];
    for (i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) show(els[i]); else later.push(els[i]);
    }
    /* прятать можно только теперь, когда наблюдатель точно есть */
    root.classList.add('eb-reveal-on');
    for (i = 0; i < later.length; i++) revealIo.observe(later[i]);
  };

  /* Уменьшенное движение могут включить во время визита */
  var reducedFns = [];
  EB.onReduced = function (fn) { if (typeof fn === 'function') reducedFns.push(fn); };

  function reducedChanged() {
    EB.reduced = !!mq.matches;
    if (EB.reduced) {
      var hidden = doc.querySelectorAll('.eb-reveal:not(.is-inview)');
      for (var i = 0; i < hidden.length; i++) show(hidden[i]);
    }
    for (var j = 0; j < reducedFns.length; j++) {
      try { reducedFns[j](EB.reduced); } catch (e) { if (window.console) console.error(e); }
    }
    refresh();
  }
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', reducedChanged);
    else if (mq.addListener) mq.addListener(reducedChanged);
  }

  /* Редактор темы: секцию перерисовали или убрали */
  doc.addEventListener('shopify:section:load', function (e) {
    purge();
    EB.reveal(e.target);
    refresh();
  });
  doc.addEventListener('shopify:section:unload', function () { setTimeout(purge, 0); });

  root.classList.add('eb-js');
  window.EB = EB;

  function init() {
    EB.reveal(doc);
    refresh();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();

  try { doc.dispatchEvent(new CustomEvent('eb:ready')); } catch (e) { /* старый браузер без CustomEvent: объект всё равно в window.EB */ }
})();
